/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import deserialize from 'cio/utils/conditions/deserialize';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

import SegmentModel from 'cio/models/segment';
import FiltersService from 'cio/services/filters';

interface CioSegmentPopoverArgs {
  segment: SegmentModel;
}

export default class CioSegmentPopover extends Component<CioSegmentPopoverArgs> {
  @service filters!: FiltersService;

  get conditionGroup() {
    return deserialize(this.args.segment.conditions);
  }

  @action
  processFilters() {
    if (this.args.segment.isDynamic) {
      this.filters.processIfEmptyOrStale.perform();
    }
  }
}
